import { type ReactNode, useState } from 'react';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { useSidebar } from '@/contexts/SidebarContext';
import { cn } from '@/lib/utils';

interface AppShellProps {
  children: ReactNode;
  activePanel: string;
  onPanelChange: (panel: string) => void;
}

export function AppShell({ children, activePanel, onPanelChange }: AppShellProps) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { pinned } = useSidebar();

  return (
    <div className="min-h-screen flex bg-bg text-fg">
      <Sidebar
        activePanel={activePanel}
        onPanelChange={(p) => { onPanelChange(p); setMobileOpen(false); }}
        mobileOpen={mobileOpen}
        onClose={() => setMobileOpen(false)}
      />
      <div
        className={cn(
          'flex-1 flex flex-col min-w-0',
          'transition-[margin] duration-300 ease-out-expo',
          pinned ? 'lg:ml-64' : 'lg:ml-16',
        )}
      >
        <TopBar onMobileMenu={() => setMobileOpen(true)} />
        <main className="flex-1 px-4 sm:px-6 lg:px-8 pt-8 pb-32 overflow-x-hidden">{children}</main>
      </div>
    </div>
  );
}
